import RestApiModel from "@/api/Model/RestApiModel";

class RiskCode extends RestApiModel {
  static getResourceEndpoint() {
    return '/risk-codes';
  }
}

export default RiskCode;
